import * as React from "react";
import HeaderWithLine from "../../common/headerWithLine/headerWithLine";
import {Container, Grid, GridItem} from "@chakra-ui/react";
import PostBox from "../../common/blogPosts/postBox";

export default function InterestedPost(props){

    const interested = props.interested
    const lang = props.lang ?? 'PL'
    return(
        <>
            {interested && <Container mx={{lg:'60px',xxl:'auto'}} maxW={{base:'100%',lg:'calc(100% - 120px)', xxl: 'container.xxl'}} mt={'2rem'} px={{base:'20px', lg: '0'}}>
                <HeaderWithLine text={lang === 'EN' ? 'You may be interested in:' : 'Być może zainteresują Cię:'} mb={'30px'}/>
                    <Grid templateColumns={{base: '1fr', lg: '1fr 1fr 1fr'}} gap={{base: '80px'}} mb={'50px'} position={'relative'}>
                        {interested.map((node, i) => (
                            <GridItem key={node.id}><PostBox node={node} i={i}/></GridItem>
                        ))}
                    </Grid>
                </Container>
            }
        </>
    )
}